import { useEffect } from "react";

function setMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setProperty(property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

interface PageMeta {
  title: string;
  description: string;
  keywords: string;
}

export default function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);
    setProperty("og:title", title);
    setProperty("og:description", description);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [title, description, keywords]);
}